@import '../../global/style/all-tenants/custom-properties/components-properties/dynamic-teaser';

:host {
  min-height: -moz-fit-content;
  min-height: fit-content;
  display: block;
  max-width: var(--cms-container-max-width);
  margin: 0 auto var(--cms-components-mb) auto;
  @include cms-base-font-100;
}

.teaser-list-container-inner {
  @include cms-default-grid-container;
}

.badge-wrapper {
  @include dynamic-teaser-badge
}

.display-none {
  display: none;
}

.more-button-wrapper {
  @include cms-default-grid-container;
}

.load-more-teaser {
  @include cms-load-more-teaser;
}

.scratch svg path {
  fill: var(--cms-semanticColors-base-medium-background);
}